function Pension(pensionData) {
  $.extend(this, pensionData)

  pensionData.secondPillar.isExitedOrSuspended = function () {
    return this.isExited || this.isSuspended
  }
  pensionData.thirdPillar.insuranceBalance = 0
  pensionData.thirdPillar.totalAssets = function() {
    return this.balance + this.insuranceBalance
  }
  pensionData.thirdPillar.assets.forEach(function (asset) {
    asset.donut = new MiniDonut().params(asset.percent);
  })
  pensionData.thirdPillar.activeFunds.forEach(function (activeFund) {
    activeFund.donut = new MiniDonut().params(activeFund.percentage);
  })
}